import React, {useEffect} from 'react';
import $ from "jquery";

function GeraeteNewModalTable(props) {

    useEffect(() => {
        //initialize datatable
        $('#newDevicesTable').DataTable({
            dom: 'frtilp', language: {
                fontcolor: 'white', url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
            }, oLanguage: {
                sSearch: '', searchPlaceholder: 'Suchen'
            }, "paging": true, "pageLength": 5
        });
    }, []);

    function addDevice(id, name) {
        if (props.geraeteDataInfo.find(item => item.name === name) === undefined) {

            props.setIsChange(false)

            id = id.toString()
            props.setGeraeteData([...props.geraeteDataInfo, {
                "id": id, "name": name
            }])

            props.geraeteDataInfo.push({"id": id, "name": name});

        } else {
            alert("Es ist schon da!")
        }
    }

    function getDevicesTableBody(devicesData) {
        let result = devicesData.filter(md =>
             props.geraeteDataInfo.every(fd => (fd.name !== md.title)))

        //let activeDevices = devicesData.filter(item => item.status === true);
        //return activeDevices?.map((item) => (<tr key={item.id}>
        return result?.map((item) => (<tr key={item.id}>
            <td onClick={() => addDevice(item.id, item.title)}>{item.title}</td>
        </tr>));
    }

    return (<div>
            <table id="newDevicesTable" className="table handwai-white-text">
                <thead>
                <tr>
                    <th>Gerät Name</th>
                </tr>
                </thead>
                <tbody>{getDevicesTableBody(props.newDeviceData)}</tbody>
            </table>
        </div>);
}

export default GeraeteNewModalTable;
